import { styled } from '@mui/material/styles';
import StyledTab from './StyledTab';
import { brandedTokens } from '@/theme/tokens';

const StyledVerticalTab = styled(StyledTab)(({ theme }) => ({
    maxWidth: 'none',
    '&.Mui-selected': {
        fontWeight: 600,
        backgroundColor: brandedTokens.variables.secondaryScale[20],
    },

    '&:hover': {
        backgroundColor: brandedTokens.variables.secondaryScale[10],
    },
}));

export default StyledVerticalTab;
